<template>
  <v-overlay z-index="3" color="background" opacity="1" absolute>
    <div class="spinner-border" role="status" />
  </v-overlay>
</template>

<script>
export default {
  mounted() {
    document.querySelector("html").style.overflowY = "hidden";
  },
  beforeDestroy() {
    document.querySelector("html").style.overflowY = "auto";
  }
};
</script>

<style scoped>
@keyframes spinner-border {
  to {
    transform: rotate(360deg);
  }
}

.spinner-border {
  display: inline-block;
  width: 5rem;
  height: 5rem;
  vertical-align: text-bottom;
  border: 0.25rem solid #455a64;
  border-right-color: transparent !important;
  border-radius: 50%;
  animation: spinner-border 0.75s linear infinite;
}
</style>
